import { NavLink } from 'react-router-dom';
import { useI18n } from '@/i18n';

export function StationBadge({ station }) {
  if (!station) return null;
  const cls = `badge-station-${station}`;
  return <span className={['LIS', 'OPO', 'FAO', 'FNC', 'PDL', 'TER', 'HQ'].includes(station) ? cls : 'badge-station bg-gray-100 text-gray-700'}>{station}</span>;
}

export function EmployerBadge({ employer }) {
  const { t } = useI18n();
  if (!employer) return null;
  return (
    <span className={employer === 'ryanair_dac' ? 'badge-employer-ryanair' : 'badge-employer-groundlink'}>
      {t(`appr.employer.${employer}`)}
    </span>
  );
}

// Tabs shared by the two approver pages.
export function ApprovalsTabs({ stations, pending }) {
  const { t } = useI18n();
  // Only approvers can reach the entitlement tab, so non-approvers (HR fallback) get no tab strip.
  if (!stations?.length) return null;
  const cls = ({ isActive }) =>
    `inline-flex items-center gap-2 min-h-[44px] px-4 text-sm font-medium border-b-2 ${
      isActive ? 'border-glk-green text-glk-green' : 'border-transparent text-gray-600 hover:text-glk-dark'}`;
  return (
    <div className="px-5 md:px-0 flex gap-1 border-b border-gray-200 mb-4">
      <NavLink to="/approvals" end className={cls}>
        {t('appr.tabInbox')}
        {pending > 0 && <span className="inline-flex min-w-[1.25rem] h-5 items-center justify-center rounded-full bg-red-600 px-1.5 text-[11px] font-semibold text-white">{pending}</span>}
      </NavLink>
      <NavLink to="/approvals/entitlements" className={cls}>{t('appr.tabEntitlements')}</NavLink>
    </div>
  );
}

export function Toast({ toast }) {
  if (!toast) return null;
  const tone = toast.kind === 'error' ? 'bg-red-50 border-red-200 text-red-800' : 'bg-green-50 border-green-200 text-green-800';
  return (
    <div role="status" aria-live="polite" className={`mb-3 px-3 py-2 border rounded-lg text-sm ${tone}`}>{toast.text}</div>
  );
}
